// extracted by mini-css-extract-plugin
module.exports = {"main":"ProductType_main__oSlXm","ending":"ProductType_ending__bRFuM"};